<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="@/assets/logo.png" height="50" alt="Logo" />
        <img class="navbar-brand-minimized" src="@/assets/logo.png" height="30" alt="Logo" />
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen="true" />
      <b-navbar-nav class="d-md-down-none">
        <!-- <b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>
        <b-nav-item class="px-3" to="/users" exact>Users</b-nav-item>-->
        <b-nav-item>
          <h4 class="text-center">Naoki Japanese Restaurant</h4>
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <!-- <b-nav-item class="d-md-down-none">
          <i class="icon-bell"></i>
          <b-badge pill variant="danger">5</b-badge>
        </b-nav-item>
        <b-nav-item class="d-md-down-none">
          <i class="icon-list"></i>
        </b-nav-item>
        <b-nav-item class="d-md-down-none">
          <i class="icon-location-pin"></i>
        </b-nav-item>-->
        <TopRightMenu />
      </b-navbar-nav>
      <!-- <AsideToggler class="d-none d-lg-block" /> -->
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <!-- <SidebarForm /> -->
        <SidebarNav :navItems="navItems" />
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <Breadcrumb v-if="list" :list="list" />
        <div class="container-fluid">
          <router-view />
        </div>
      </main>
    </div>
    <TheFooter>
      <div>
        <a href="https://www.facebook.com/naokijapanese/" target="_blank">Naoki</a>
        &copy; 2019.
      </div>
      <div class="ml-auto">
        <span class="mr-1">
          Powered by
          <a href="https://jipnoii.com/" target="_blank">Jipnoii</a>
        </span>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import Vue from "vue";
import firebase from "firebase";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  // SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb
} from "@coreui/vue";
import TopRightMenu from "./TopRightMenu";
import { get } from "vuex-pathify";
export default {
  name: "TopNav",
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    TopRightMenu,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  computed: {
    user: get("user"),
    list() {
      return this.$route.matched.filter(
        route => route.name || route.meta.label
      );
    },
    navItems() {
      // if (this.user && this.user === "admin") return this.nav;
      // else
      // return this._.filter(this.nav, n => n.role !== "admin");
      return this.nav;
    }
  },
  data() {
    return {
      today: null,
      nav: [
        {
          name: this.t(["Dashboard", "ໜ້າຫຼັກ"]),
          url: "/home",
          icon: "icon-speedometer"
        },
        {
          name: this.t(["Orders", "ອໍເດີ"]),
          url: "/orders",
          icon: "icon-speech",
          badge: null
        },
        {
          name: this.t(["Time", "ເວລາ ປິດ-ເປີດ"]),
          url: "/times",
          icon: "icon-clock",
          badge: null
        },
        {
          name: this.t(["Settings", "ການຕັ້ງຄ່າ"]),
          url: "/settings",
          icon: "icon-wrench",
          badge: null
        },
        {
          name: this.t(["Customers", "ລູກຄ້າ"]),
          url: "/customers",
          icon: "icon-people",
          badge: null
        },
        {
          name: this.t(["Categories", "ໝວດເມນູອາຫານ"]),
          url: "/categories",
          icon: "icon-list",
          badge: null
        },
        {
          name: this.t(["Menus", "ເມນູ"]),
          url: "/menus",
          icon: "icon-list",
          badge: null
        },
        {
          name: this.t(["Promotions", "ໂປໂມຊັນ"]),
          url: "/promotions",
          icon: "icon-tag",
          badge: null
        },
        {
          name: this.t(["Push", "ການແຈ້ງເຕືອນ"]),
          url: "/push",
          icon: "icon-paper-plane",
          badge: null
        },
        {
          name: this.t(["Employees", "ພະນັກງານ"]),
          url: "/employees",
          icon: "icon-people",
          badge: null
        },
        {
          name: this.t(["Report Top Menus", "ລານງານເມນູຂາຍດີ"]),
          meta: { label: "Report Top Menus" },
          url: "/reportTopMenus",
          icon: "icon-chart"
        },
        {
          name: this.t(["Report Top Customers", "ລາຍງານລູກຄ້າປະຈຳ"]),
          meta: { label: "Report Top Customers" },
          url: "/reportTopCustomers",
          icon: "icon-chart"
        }
      ]
    };
  },
  mounted() {
    this.get();
  },
  methods: {
    get() {
      firebase
        .firestore()
        .collection("orders")
        .where("orderStatus", "==", 0)
        .get()
        .then(res => {
          if (res.size > 0) this.getBadge(1, "danger", "*");

          this.today = this.moment()
            .startOf("day")
            .format("YYYY-MM-DD");
        });
      this.getBadgeAll("payments", 2, "success");
    },
    getBadgeAll(collection, menuIndex, variant) {
      firebase
        .firestore()
        .collection(collection)
        .get()
        .then(res => {
          this.getBadge(menuIndex, variant, res.size);
        });
    },
    getBadge(menuIndex, variant, text) {
      this.nav.forEach((n, i) => {
        if (i == menuIndex) {
          n.badge = {
            variant: variant,
            text: text
          };
        }
      });
    }
  }
};
</script>
